import { columnists } from '@/mocks/home';
import SectionHeading from '@/components/feature/SectionHeading';

export default function Columnists() {
  return (
    <section id="authors" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="EDITORS"
          title="专栏作者 · 深扒的人"
          desc="每篇深扒背后都有一个署名。谁在挖、挖到什么程度、依据什么判断，都可以对照署名去追溯。"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {columnists.map((author) => (
            <article
              key={author.id}
              className="group flex flex-col rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors p-5"
            >
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 md:w-[72px] md:h-[72px] shrink-0 rounded-full overflow-hidden bg-background-200 border-2 border-background-100">
                  <img
                    src={author.image}
                    alt={`${author.name} 专栏作者头像`}
                    title={`${author.name} · 18爆料网专栏作者`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-lg text-foreground-950">{author.name}</h3>
                  <span className="mt-0.5 inline-block px-2 py-0.5 rounded bg-accent-100 text-accent-900 text-[11px] font-medium">
                    {author.role}
                  </span>
                </div>
              </div>

              <p className="mt-4 text-sm text-foreground-600 leading-relaxed flex-1">{author.bio}</p>

              <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between">
                <div className="flex items-center gap-5 text-xs text-foreground-500">
                  <span>
                    <strong className="font-heading text-base text-foreground-950">{author.posts}</strong> 篇
                  </span>
                  <span>
                    <strong className="font-heading text-base text-foreground-950">{author.followers}</strong> 关注
                  </span>
                </div>
                <a
                  href="#subscribe"
                  className="inline-flex items-center gap-1.5 h-9 px-3.5 rounded-md bg-secondary-100 text-secondary-900 text-xs font-medium hover:bg-secondary-200 transition-colors whitespace-nowrap"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-add-line text-base" />
                  </span>
                  关注
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}